/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bell_Activity_Proposals_OneInputs */

const en_bell_activity_proposals_one = /** @type {(inputs: Bell_Activity_Proposals_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`proposals on 1 line`)
};

/**
* | output |
* | --- |
* | "proposals on 1 line" |
*
* @param {Bell_Activity_Proposals_OneInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const bell_activity_proposals_one = /** @type {((inputs?: Bell_Activity_Proposals_OneInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bell_Activity_Proposals_OneInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_bell_activity_proposals_one(inputs)
});